import React from 'react';
import {useIntl} from 'react-intl';
import styles from './styles.module.scss';

const InvalidEmailMessage = () => {
  const intl = useIntl();

  return (
    <div className={styles.invalidEmailMessage}>
      {intl.formatMessage({id: 'invalid-email-message', defaultMessage: 'Invalid email'})}
    </div>
  );
};

export default InvalidEmailMessage;
